module.exports = __webpack_public_path__ + "static/climateactive-certified-product-e1aad2f060b9874ef2d8fa29ef2251fa.png";